import store from "@/store";
import router from "@/router";
import {
  MODULE_PREFIX_HOME,
  MODULE_PREFIX_USER,
  MODULE_PREFIX_MAP_CONTROLS,
} from "@/store";
import {
  GET_SELECTOR_PANEL,
  GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID,
} from "@/store/actions.type";
import { DETAIL_SIDEBAR_TYPES } from "@/common/constants/home";
import { UNSHIFT_EOS_HISTORY } from "@/store/mutations.type";

/**
 * Open a content page by updating the store and triggering page navigation
 *
 * The URI passed should omit any route prefix and start with a leading `/`
 *
 * The URI should also exist in `Eos` under the `/seerist` prefix
 *
 * @param {String} uri a URI string like `/risk-ratings/changes/199`, or omit if the URL does not need to be updated
 * @param {String} event an event key that can be used to open a page from within EOS
 * @param {String} state a state key that can be used to open a page from within EOS
 */
export async function openContentPage(uri, { event, state } = {}) {
  if (event && state) {
    await store.dispatch(MODULE_PREFIX_HOME + UNSHIFT_EOS_HISTORY, {
      event,
      state,
    });
  }

  await store.dispatch(MODULE_PREFIX_HOME + GET_SELECTOR_PANEL, {
    ...store.getters[MODULE_PREFIX_HOME + "selectorPanel"],
    visible: true,
    isSelected: true,
    selected: DETAIL_SIDEBAR_TYPES.content,
  });
  if (uri) {
    router.push(`/${DETAIL_SIDEBAR_TYPES.content + uri}`);
  }
}

/**
 * Open the users configured home page, the map by default or latest if configured
 */
export async function openHomePage() {
  const preferences = store.getters[MODULE_PREFIX_USER + "preferences"];
  const selectorPanel = store.getters[MODULE_PREFIX_HOME + "selectorPanel"];
  const isLandingPage = preferences?.home?.landingPage;

  await store.dispatch(MODULE_PREFIX_HOME + GET_SELECTOR_PANEL, {
    ...selectorPanel,
    visible: !!isLandingPage,
    isSelected: !!isLandingPage,
    selected: isLandingPage ? DETAIL_SIDEBAR_TYPES.latest : null,
  });

  router.push(isLandingPage ? "/latest" : "/home");
}

/**
 * Open a country page w/ a given country code
 *
 * @param {String} code - A country iso2 code
 */
export async function openCountryPage(code) {
  await store.dispatch(MODULE_PREFIX_HOME + GET_SELECTOR_PANEL, {
    ...store.getters[MODULE_PREFIX_HOME + "selectorPanel"],
    visible: true,
    isSelected: true,
    selected: DETAIL_SIDEBAR_TYPES.stability,
    selectedData: { code },
  });
  window.history.replaceState({}, "Seerist", "/");
}

export function addExternalMapLayerToMap(id) {
  store.dispatch(
    MODULE_PREFIX_MAP_CONTROLS + GET_MAP_CONTROLS_EXTERNAL_SOURCE_ID,
    id
  );
}
